import { render } from "./ExameDetalheView.vue?vue&type=template&id=613702d6"
import script from "./ExameDetalheView.vue?vue&type=script&lang=js"
export * from "./ExameDetalheView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__